"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionPageDataProvider = exports.useRetentionPageDataContext = void 0;
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const React = __importStar(require("react"));
const react_1 = require("react");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const ProjectDashboardDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/ProjectDashboardDataProvider");
const react_dom_1 = require("react-dom");
const RetentionJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionJSONModel");
const RetentionDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionDataProvider");
const react_router_dom_1 = require("react-router-dom");
const RetentionPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionPageModelProvider");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
const isFakeData = process.env.NODE_ENV === "development" && false;
const RetentionPageDataContext = React.createContext(undefined);
const useRetentionPageDataContext = () => {
    const context = React.useContext(RetentionPageDataContext);
    if (!context) {
        throw new Error("useRetentionPageDataContext must be used within a RetentionPageDataContext.Provider");
    }
    return context;
};
exports.useRetentionPageDataContext = useRetentionPageDataContext;
const TEMP_FN = () => null;
const RetentionPageDataProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const retentionDataContext = (0, RetentionDataProvider_1.useRetentionDataContext)();
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [state, setState] = (0, react_1.useReducer)(
    // (state, newState) => ({...state, ...newState}),
    DataProviderCommonTypes_1.simpleFeatureReducer, lodash_1.default.cloneDeep(DataProviderCommonTypes_1.initialDataProviderState));
    const [urlState, setURLState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), (0, RetentionPageModelProvider_1.deserializeRetentionJSONModelFromQueryString)(location.search).serialize());
    const serializedStateData = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        const compositeChartJSONModelFromURL = (0, RetentionPageModelProvider_1.deserializeRetentionJSONModelFromQueryString)(location.search);
        const serializedState = compositeChartJSONModelFromURL.serialize();
        const serializedStateChart = serializedState.chart;
        serializedState.chart = undefined;
        return {
            serializedState: serializedState,
            serializedStateChart: serializedStateChart
        };
    }, [location.search, TEMP_FN], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Change URL state only when ChartSettings changes.
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        const compositeChartJSONModel = (0, RetentionPageModelProvider_1.deserializeRetentionJSONModelFromQueryString)(location.search);
        setURLState(compositeChartJSONModel.serialize());
    }, [projectApiKey, serializedStateData.serializedStateChart, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Fetch data on page URL state change (!!! IMPORTANT: without ChartSettings !!!)
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        if (isMounted()) {
            (async () => {
                const jsonModel = (0, RetentionPageModelProvider_1.deserializeRetentionJSONModelFromQueryString)(location.search);
                const newDataState = {};
                if (!RetentionJSONModel_1.RetentionJSONModel.isModelEmpty(jsonModel.serialize())) {
                    const lastNDays = jsonModel.getPeriodDaysJSONModel().getLast();
                    const retentionType = jsonModel.getRetentionTypeJSONModel().getType();
                    const tabsJSONModel = jsonModel.getTabsJSONModel();
                    const activeTabUniqueId = tabsJSONModel.getActiveUniqueId();
                    const cohortJSONModel = tabsJSONModel.getCohortJSONModel(activeTabUniqueId);
                    const cohortQuery = (cohortJSONModel === null || cohortJSONModel === void 0 ? void 0 : cohortJSONModel.getQueryEventVariantArray()) || [];
                    const retentionJSONModel = tabsJSONModel.getReturnJSONModel(activeTabUniqueId);
                    const returnQuery = (retentionJSONModel === null || retentionJSONModel === void 0 ? void 0 : retentionJSONModel.getQueryEventVariantArray()) || [];
                    const requestParams = {
                        periodType: CommonTypesConversions_1.CommonTypesConversions.periodType.fromLastNDays(lastNDays),
                        retentionType: CommonTypesConversions_1.CommonTypesConversions.retentionType.retentionTypeTypeToRetentionType(retentionType),
                        cohortQuery: cohortQuery,
                        returnQuery: returnQuery
                    };
                    (0, react_dom_1.unstable_batchedUpdates)(() => {
                        setState({ status: { inProgress: true } });
                    });
                    try {
                        let projectRetentionResultByChunksFeatureState = await retentionDataContext.fetchRetention(requestParams);
                        // console.log("projectRetentionResultByChunksFeatureState", projectRetentionResultByChunksFeatureState);
                        if (isFakeData) {
                            projectRetentionResultByChunksFeatureState = (0, DataProviderCommonTypes_1.getFeatureStateFromICResult)({ ok: ProjectDashboardDataProvider_1.D_Retention });
                        }
                        //error
                        if (projectRetentionResultByChunksFeatureState.isError) {
                            newDataState.error = {
                                isError: true,
                                error: projectRetentionResultByChunksFeatureState.error,
                            };
                        }
                        else {
                            newDataState.error = {
                                error: undefined,
                                isError: false
                            };
                        }
                        //data
                        newDataState.data = {
                            request: requestParams,
                            response: projectRetentionResultByChunksFeatureState.state
                        };
                    }
                    catch (e) {
                        newDataState.error = {
                            error: e,
                            isError: true
                        };
                    }
                    newDataState.status = {
                        loaded: true,
                        inProgress: false
                    };
                }
                else {
                    newDataState.data = undefined;
                }
                (0, react_dom_1.unstable_batchedUpdates)(() => {
                    setURLState(jsonModel.serialize());
                    setState(newDataState);
                });
            })();
        }
    }, [projectApiKey, serializedStateData.serializedState, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Get URL JSON Model
    ////////////////////////////////////////////////
    const getURLJSONModel = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        return new RetentionJSONModel_1.RetentionJSONModel(urlState);
    }, [urlState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Chart Settings Changed
    ////////////////////////////////////////////////
    const onChartSettingsChanged = (0, use_custom_compare_1.useCustomCompareCallback)((chartSettings) => {
        const jsonModel = new RetentionJSONModel_1.RetentionJSONModel(urlState);
        jsonModel.getChartSettingsJSONModel().overwriteFromSerializedState(chartSettings);
        const serializedState = jsonModel.serialize();
        const newUrl = AppRouting_1.AppPathGenerator.Project.retention(projectApiKey, serializedState);
        history.push(newUrl);
    }, [urlState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Return value
    ////////////////////////////////////////////////
    const stateFns = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        getURLJSONModel,
        onChartSettingsChanged,
    }), [
        getURLJSONModel,
        onChartSettingsChanged,
    ], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        state,
        urlState,
        stateFns,
    }), [
        state,
        urlState,
        stateFns,
    ], lodash_1.default.isEqual);
    return React.createElement(RetentionPageDataContext.Provider, { value: value }, props.children);
};
exports.RetentionPageDataProvider = RetentionPageDataProvider;
